import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { useT } from '../app/i18n.tsx';

/** A change against the previous period as a small badge: the arrow and the percentage, good or bad. */
export function Delta({ current, previous, goodWhenUp }: { current: bigint; previous: bigint; goodWhenUp: boolean }) {
  const t = useT();
  if (previous === 0n) return null;
  const change = Number(((current - previous) * 1000n) / (previous < 0n ? -previous : previous)) / 10;
  if (!Number.isFinite(change)) return null;
  const up = change > 0;
  const good = change === 0 ? null : up === goodWhenUp;
  const Icon = change === 0 ? Minus : up ? ArrowUpRight : ArrowDownRight;
  return (
    <span className={`delta ${good === null ? 'delta--neutral' : good ? 'delta--good' : 'delta--bad'}`}>
      <Icon aria-hidden="true" />
      {new Intl.NumberFormat(t.locale, { maximumFractionDigits: 1, signDisplay: 'exceptZero' }).format(change)}%
    </span>
  );
}
